<div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2">
    {{ demandAggregation? "Produktinformationen - Vorvermarktung" : "Produktinformationen" }}
</div>
Download:<br />
Minimale Übertragungsrate: {{ baseProduct!.marketingInformation.speedDown * 0.8}} Mbit/s<br />
Normale Übertragungsrate: {{ baseProduct!.marketingInformation.speedDown * 0.9 }} Mbit/s<br />
Maximale Übertragungsrate: {{ baseProduct!.marketingInformation.speedDown }} Mbit/s<br /><br />
Upload:<br />
Minimale Übertragungsrate: {{ baseProduct!.marketingInformation.speedUp * 0.8 }} Mbit/s<br />
Normale Übertragungsrate: {{ baseProduct!.marketingInformation.speedUp * 0.9 }} Mbit/s<br />
Maximale Übertragungsrate: {{ baseProduct!.marketingInformation.speedUp }} Mbit/s<br /><br />
Mindestvertragslaufzeit (MVLZ): {{ baseProduct!.marketingInformation.contractTime > 0 ? baseProduct!.marketingInformation.contractTime : 24 }} Monate<br />
Kündigungsfrist: nach jeweils gesetzlich gültiger Frist<br /><br />
Verlängerung bei Nichtkündigung: unbefristet<br />
Kündigungsfrist bei Verlängerung: Monatlich kündbar<br /><br />
Datum der Markteinführung: {{ baseProduct!.startDate | date }}
